"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = exports.PrimaryTabs = void 0;
var PrimaryTabs_1 = require("./PrimaryTabs");
Object.defineProperty(exports, "PrimaryTabs", { enumerable: true, get: function () { return __importDefault(PrimaryTabs_1).default; } });
var Tabs_1 = require("./Tabs");
Object.defineProperty(exports, "Tabs", { enumerable: true, get: function () { return __importDefault(Tabs_1).default; } });
